var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-support",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1579",
    "data-name": "Rectangle 1579",
    width: 28,
    height: 28,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support-svgrepo-com",
    transform: "translate(-9.76 1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M89.394,148.084a3.347,3.347,0,1,0,3.347,3.347A3.351,3.351,0,0,0,89.394,148.084Zm0,5.469a2.122,2.122,0,1,1,2.122-2.122A2.124,2.124,0,0,1,89.394,153.553Z",
    transform: "translate(-67.662 -135.993)",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M32.39,0H24.844a2.763,2.763,0,0,0-2.76,2.761V6.075h-1.6a.612.612,0,0,0-.612.612V7.756a7.78,7.78,0,0,0-2.252.933l-.756-.756a.612.612,0,0,0-.866,0L14.227,9.7a.613.613,0,0,0,0,.866l.756.756a7.78,7.78,0,0,0-.933,2.252H12.981a.612.612,0,0,0-.612.612v2.5a.612.612,0,0,0,.612.612H14.05a7.783,7.783,0,0,0,.933,2.252l-.756.756a.613.613,0,0,0,0,.866L16,22.942a.613.613,0,0,0,.866,0l.756-.756a7.782,7.782,0,0,0,2.252.933v1.069a.612.612,0,0,0,.612.612h2.5a.612.612,0,0,0,.612-.612V23.119a7.779,7.779,0,0,0,2.252-.933l.756.756a.613.613,0,0,0,.866,0l1.768-1.768a.613.613,0,0,0,0-.866l-.756-.756a7.782,7.782,0,0,0,.933-2.252h1.069a.612.612,0,0,0,.612-.612v-2.5a.612.612,0,0,0-.612-.612H29.413a7.79,7.79,0,0,0-.254-.838L30.32,11.9h2.07a2.764,2.764,0,0,0,2.76-2.761V2.761A2.764,2.764,0,0,0,32.39,0ZM28.311,14.292a.612.612,0,0,0,.6.508h.955v1.275h-.955a.613.613,0,0,0-.6.508,6.594,6.594,0,0,1-1.117,2.7.612.612,0,0,0,.068.786l.676.675-.9.9-.676-.675a.612.612,0,0,0-.786-.067,6.6,6.6,0,0,1-2.7,1.117.612.612,0,0,0-.508.6v.955H21.094v-.955a.613.613,0,0,0-.508-.6,6.593,6.593,0,0,1-2.7-1.117.612.612,0,0,0-.786.067l-.675.675-.9-.9.675-.675a.612.612,0,0,0,.068-.786,6.6,6.6,0,0,1-1.117-2.7.612.612,0,0,0-.6-.508h-.955V14.8h.955a.612.612,0,0,0,.6-.508,6.6,6.6,0,0,1,1.117-2.7.612.612,0,0,0-.068-.786l-.675-.675.9-.9.675.675a.612.612,0,0,0,.786.067,6.6,6.6,0,0,1,2.7-1.117.612.612,0,0,0,.508-.6V7.3h.991V9.141a2.764,2.764,0,0,0,2.76,2.761h.616v2.3a.612.612,0,0,0,.97.5l1.689-1.216A6.714,6.714,0,0,1,28.311,14.292Zm5.614-5.151a1.537,1.537,0,0,1-1.535,1.536H30.122a.612.612,0,0,0-.358.115L26.685,13.01v-1.72a.612.612,0,0,0-.612-.612H24.844a1.537,1.537,0,0,1-1.535-1.536V2.761a1.537,1.537,0,0,1,1.535-1.536H32.39a1.537,1.537,0,0,1,1.535,1.536Z",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M181.746,24.636a2.562,2.562,0,0,0-2.559,2.559.612.612,0,0,0,1.225,0,1.334,1.334,0,1,1,2.668,0c0,.737-.952,1.679-1.582,2.3l-.185.184a.612.612,0,0,0,.866.866l.181-.18c.821-.813,1.945-1.926,1.945-3.173A2.562,2.562,0,0,0,181.746,24.636Z",
    transform: "translate(-153.197 -22.624)",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M200.1,105.738a.735.735,0,1,0,.52.216A.737.737,0,0,0,200.1,105.738Z",
    transform: "translate(-171.729 -97.104)",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.39d819ebe476a1a2ead929b24be554a9.svg";
export { ForwardRef as ReactComponent };